/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phones/view.blocks to change it.
import AddPhoneNumber from './AddPhoneNumber/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
let PhoneNumbers = React.lazy(() => import('./PhoneNumbers/index'))



/** @type {import('Simple/types.js').View} */
export default function Phones({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Comms/Phones"
  
}) {
  return (<React.Fragment
>
<AddPhoneNumber
  viewPath={`${viewPath}/AddPhoneNumber`}
/>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<PhoneNumbers
{...childProps}
  viewPath={`${viewPath}/PhoneNumbers`}
/>
)}
</SuspenseBoundary>
{children}
</React.Fragment>)
}